import type { Technique } from '../types';
import { DLA_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type DlaState } from './render';

export const dla: Technique<DlaState> = {
  id: 'dla',
  name: 'Diffusion-Limited Aggregation',
  category: 'growth',
  description: 'Wanderpartikel kleben an der Textkontur an und wachsen zu fraktalen Ästen.',
  params: DLA_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
